module.exports = __webpack_public_path__ + "img/stars-green.0ee33c19.svg";